"use strict";
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceCollector = void 0;
/**
 * ResourceCollector class implements asynchronous logic of calling the API call that supports pagination,
 * page by page, collecting all resources (up to `maxResults`) in the array.
 *
 * Usage:
 *   const resourceCollector = new ResourceCollector(apiCall, maxResults); // -1 for unlimited
 *   resourceCollector.processAllPages(request).then(resources => ...);
 */

var ResourceCollector =
/*#__PURE__*/
function () {
  function ResourceCollector(apiCall) {
    var maxResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    _classCallCheck(this, ResourceCollector);

    this.apiCall = apiCall;
    this.resources = [];
    this.maxResults = maxResults;
  }

  _createClass(ResourceCollector, [{
    key: "callback",
    value: function callback(err, resources, nextPageRequest) {
      var _this = this;

      if (err) {
        // Something went wrong with this request - failing everything
        this.rejectCallback(err);
        return;
      } // Process one page


      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = resources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var resource = _step.value;
          this.resources.push(resource);

          if (this.resources.length === this.maxResults) {
            nextPageRequest = null;
            break;
          }
        } // All done?

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!nextPageRequest) {
        this.resolveCallback(this.resources);
        return;
      } // Schedule the next call


      var callback = function callback() {
        return _this.callback.apply(_this, arguments);
      };

      setImmediate(this.apiCall, nextPageRequest, callback);
    }
  }, {
    key: "processAllPages",
    value: function processAllPages(firstRequest) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.resolveCallback = resolve;
        _this2.rejectCallback = reject; // Schedule the first call

        var callback = function callback() {
          return _this2.callback.apply(_this2, arguments);
        };

        setImmediate(_this2.apiCall, firstRequest, callback);
      });
    }
  }]);

  return ResourceCollector;
}();

exports.ResourceCollector = ResourceCollector;